module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-edital"
  }, [(_vm.mostrarCriarProposta) ? _c('div', {
    staticClass: "edital-modal-container column all-centered"
  }, [_c('div', {
    staticClass: "edital-modal-mensagem column centered-start"
  }, [_vm._m(0), _vm._v(" "), (_vm.entidadesExistentes.length > 0 && _vm._.has(_vm.entidadesExistentes[0], 'ds_nome') && !_vm._.isNull(_vm.entidadesExistentes[0].ds_nome)) ? _c('div', {
    staticClass: "edital-content-container column all-centered"
  }, [_c('span', {
    staticClass: "edital-subtitulo"
  }, [_vm._v("Ótimo! Verificamos que a entidade tem um cadastro na Fundação BB.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.entidadesExistentes), function(entidade) {
    return _c('p', {
      staticClass: "edital-link"
    }, [_c('router-link', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          placement: 'right',
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
      }],
      attrs: {
        "title": '<h5>Clique aqui para atualizar o cadastro da entidade</h5>',
        "to": {
          name: 'cadastro-entidade-edita',
          params: {
            id: entidade.id
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm._f("cnpj")(entidade.ds_cnpj)) + " -\n                  " + _vm._s(entidade.ds_nome) + "\n                  (" + _vm._s(entidade.ds_nome_fantasia) + ")\n                  "), _c('i', {
      staticClass: "fa fa-external-link"
    })])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "column all-centered email-edital-container"
  }, [_c('div', [_vm._v("\n                  Atenção, caso o e-mail de acesso "), _c('b', [_vm._v("não")]), _vm._v(" seja nenhum desses listados abaixo, entre em contato com a Fundação BB pelo e-mail "), _c('b', [_vm._v(_vm._s(_vm.listaEditais[0].ds_numero_edital === 'ECOFORTE REDES 2024' ? 'ecoforte@fbb.org.br' : 'cataforte@fbb.org.br'))]), _vm._v(", constando o assunto: "), _c('b', [_vm._v(_vm._s(_vm.listaEditais[0].ds_numero_edital === 'ECOFORTE REDES 2024' ? 'SGP – CHAMADA PÚBLICA Nº 2024/007' : 'SGP – CHAMADA PÚBLICA Nº 2024/008'))]), _vm._v(". Você deverá anexar "), _c('b', [_vm._v("cópia da ata de eleição e posse")]), _vm._v(", "), _c('b', [_vm._v("documento do representante legal")]), _vm._v(" e informar o "), _c('b', [_vm._v("novo e-mail da entidade")]), _vm._v(", para que seu acesso possa ser regularizado. \n                ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.emailsEntidades), function(email) {
    return _c('div', {
      staticClass: "edital-titulo"
    }, [_vm._v("\n                  " + _vm._s(email) + "\n                ")])
  })], 2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-centered botao-edital-container"
  }, [((_vm.mostrarForm && !_vm.mostrarArquivo && _vm.mostrarCriarProposta) && !_vm.gravando) ? _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.criaPropostaEdital()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Criar Proposta ")]) : _vm._e(), _vm._v(" "), ((_vm.mostrarForm && !_vm.mostrarArquivo && _vm.mostrarCriarProposta)) ? _c('g-button-moema', {
    attrs: {
      "color": "error",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelarEnvioEntidadeCadastrada()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar ")]) : _vm._e()], 1)], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-box",
    staticStyle: {
      "width": "60%",
      "height": "auto"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "login-box-body"
  }, [_c('div', {
    staticClass: "box box-widget col-md-14",
    staticStyle: {
      "border": "none",
      "box-shadow": "none"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.telaTodosEditais) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Razão social')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "edital_selecao"
    }
  }, [_vm._v(_vm._s(_vm.rotuloSelecaoEdital))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editalAtivoSelecionado),
      expression: "editalAtivoSelecionado"
    }],
    attrs: {
      "name": "select",
      "placeholder": "Selecione um Edital Ativo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editalAtivoSelecionado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selecionaAtivo()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecione um Edital Ativo")]), _vm._v(" "), _vm._l((_vm.listaEditais), function(edital) {
    return _c('option', {
      domProps: {
        "value": edital.parametro
      }
    }, [_vm._v(_vm._s(edital.ds_numero_edital))])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (!_vm.telaTodosEditais) ? _c('div', {
    staticClass: "box-body form-horizontal",
    attrs: {
      "ssm-lte-loading": "loading-info"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Razão social')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "edital_selecao"
    }
  }, [_vm._v(_vm._s(_vm.rotuloSelecaoEdital))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaEditais,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione um Edital",
      "label": "ds_numero_edital",
      "track-by": "ds_numero_edital",
      "custom-label": _vm.etiquetaEdital,
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "editais",
      "data-vv-as": "Editais",
      "preselect-first": true,
      "disabled": _vm.desabilitaListaEditais
    },
    on: {
      "select": function($event) {
        return _vm.selecionado($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.ds_numero_edital))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }], null, false, 3121837327),
    model: {
      value: (_vm.entidade.proposta.edital),
      callback: function($$v) {
        _vm.$set(_vm.entidade.proposta, "edital", $$v)
      },
      expression: "entidade.proposta.edital"
    }
  })], 1)]), _vm._v(" "), (_vm.mostrarForm && _vm.mostrarArquivo) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('legend', [_vm._v("Anexe a planilha de cadastro da entidade para preenchimento automático dos dados abaixo:")]), _vm._v(" "), _c('div', {
    staticClass: "box-header with-border"
  }, [_c('importacao-excel', {
    attrs: {
      "modelo": 'cadastro_entidade'
    },
    on: {
      "analiseExcel": function($event) {
        _vm.validacaoArquivo = $event
      },
      "objetoExcel": function($event) {
        _vm.excel = $event
      }
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.mostrarForm === true) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-horizontal col-md-14",
    attrs: {
      "name": "frmAutoRegister"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CNPJ')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "CNPJ"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('the-mask', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|cnpj|min:14|max:14'),
      expression: "'required|cnpj|min:14|max:14'"
    }],
    ref: "CNPJ",
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ",
      "data-vv-as": "CNPJ",
      "type": "text",
      "title": 'Informe o CNPJ da sua entidade.',
      "mask": "##.###.###/####-##"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.verificaCNPJEntidade($event)
      }
    },
    model: {
      value: (_vm.entidade.ds_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "ds_cnpj", $$v)
      },
      expression: "entidade.ds_cnpj"
    }
  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNPJ')))]) : _vm._e()], 1), _vm._v(" "), (_vm.entidadesExistentes.length > 0 && _vm._.has(_vm.entidadesExistentes[0], 'ds_nome') && !_vm._.isNull(_vm.entidadesExistentes[0].ds_nome)) ? _c('div', {
    staticClass: "col-md-offset-4 col-md-9"
  }, [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Ótimo! Verificamos que a entidade tem um cadastro na Fundação BB.")]), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Clique no link abaixo para acessar e atualizar as informações .")]), _vm._v(" "), _vm._l((_vm.entidadesExistentes), function(entidade) {
    return _c('p', [_c('router-link', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          placement: 'right',
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
      }],
      attrs: {
        "title": '<h5>Clique aqui para atualizar o cadastro da entidade</h5>',
        "to": {
          name: 'cadastro-entidade-edita',
          params: {
            id: entidade.id
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                            " + _vm._s(_vm._f("cnpj")(entidade.ds_cnpj)) + " -\n                            " + _vm._s(entidade.ds_nome) + "\n                            (" + _vm._s(entidade.ds_nome_fantasia) + ")\n                            "), _c('i', {
      staticClass: "fa fa-external-link"
    })])], 1)
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Para inscrever sua proposta clique no botão Criar Proposta no rodapé dessa página.")]), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v("Nesse caso não é necessário preencher os dados da Entidade e nem do representante legal.")])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Razão social')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_nome),
      expression: "entidade.ds_nome"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Razão social",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
      "title": 'Informe a Razão Social da sua entidade.',
      "name": "Razão social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Email')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_email),
      expression: "entidade.ds_email"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|min:1|max:255'),
      expression: "'required|email|min:1|max:255'"
    }],
    ref: "Email",
    staticClass: "form-control",
    attrs: {
      "name": "Email",
      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
      "title": 'Informe o E-mail da sua entidade.',
      "type": "text",
      "delivery": "account"
    },
    domProps: {
      "value": (_vm.entidade.ds_email)
    },
    on: {
      "change": _vm.verificaEmailEntidade,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Email')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_email === _vm.usuario.ds_email && _vm.entidade.ds_email && _vm.usuario.ds_email) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Os e-mails da entidade e do usuário não podem ser iguais!')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('emailConfirmacaoEnt')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "emailConfirmacaoEnt"
    }
  }, [_vm._v("Confirmar E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailConfirmacaoEnt),
      expression: "emailConfirmacaoEnt"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|min:1|max:255'),
      expression: "'required|email|min:1|max:255'"
    }],
    ref: "emailConfirmacaoEnt",
    staticClass: "form-control",
    attrs: {
      "name": "emailConfirmacaoEnt",
      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
      "title": 'Confirme o E-mail da sua entidade.',
      "type": "text",
      "delivery": "account",
      "method": "uniqueUserEmail"
    },
    domProps: {
      "value": (_vm.emailConfirmacaoEnt)
    },
    on: {
      "paste": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailConfirmacaoEnt = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('emailConfirmacaoEnt')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo confirmação do e-mail da entidade é obrigatório')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_email !== _vm.emailConfirmacaoEnt && _vm.emailConfirmacaoEnt.length > 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Os e-mails informados não são iguais!')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Representante Legal:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Nome')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Nome"
    }
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.ds_nome_usuario),
      expression: "usuario.ds_nome_usuario"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
      "title": 'Informe o Nome do Usuário da sua entidade.',
      "name": "Nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.ds_nome_usuario)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "ds_nome_usuario", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Nome é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Cpf')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Nome"
    }
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('the-mask', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
      "name": "Cpf",
      "type": "text",
      "data-vv-as": "CPF",
      "title": 'Informe o CPF do Usuário da sua entidade.',
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.usuario.ds_cpf),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "ds_cpf", $$v)
      },
      expression: "usuario.ds_cpf"
    }
  }), _vm._v(" "), (_vm.errors.first('Cpf')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cpf')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Login')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Nome"
    }
  }, [_vm._v("Login:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.ds_login),
      expression: "usuario.ds_login"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Login",
      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
      "title": 'Crie um login para o seu usuário.',
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.ds_login)
    },
    on: {
      "change": _vm.verificaUsuario,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "ds_login", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Login')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Login')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_cnpj === _vm.usuario.ds_login && _vm.entidade.ds_cnpj) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O login do usuário não pode ser o número do CNPJ da entidade.')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Nome"
    }
  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('the-mask', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:10|max:11'),
      expression: "'required|min:10|max:11'"
    }],
    ref: "Telefone",
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "text",
      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
      "title": 'Informe o telefone do usuário.',
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.usuario.ds_telefone),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "ds_telefone", $$v)
      },
      expression: "usuario.ds_telefone"
    }
  }), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Telefone')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('userEmail')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "userEmail"
    }
  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.ds_email),
      expression: "usuario.ds_email"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|min:1|max:255'),
      expression: "'required|email|min:1|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "userEmail",
      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
      "title": 'Informe o E-mail do Usuário da sua entidade.',
      "type": "text"
    },
    domProps: {
      "value": (_vm.usuario.ds_email)
    },
    on: {
      "change": _vm.verificaEmailUsuario,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "ds_email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('userEmail')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('userEmail')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_email === _vm.usuario.ds_email && _vm.entidade.ds_email) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Os e-mails da entidade e do usuário não podem ser iguais.')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('emailConfirmacao')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "emailConfirmacao"
    }
  }, [_vm._v("Confirmar E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailConfirmacao),
      expression: "emailConfirmacao"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|min:1|max:255'),
      expression: "'required|email|min:1|max:255'"
    }],
    ref: "emailConfirmacao",
    staticClass: "form-control",
    attrs: {
      "name": "emailConfirmacao",
      "disabled": _vm.mostrarArquivo || _vm.mostrarCriarProposta,
      "title": 'Confirme o E-mail do Usuário da sua entidade.',
      "type": "text",
      "delivery": "account",
      "method": "uniqueUserEmail"
    },
    domProps: {
      "value": (_vm.emailConfirmacao)
    },
    on: {
      "paste": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailConfirmacao = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('emailConfirmacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo confirmação do e-mail da entidade é obrigatório')))]) : _vm._e(), _vm._v(" "), (_vm.usuario.ds_email !== _vm.emailConfirmacao && _vm.emailConfirmacao.length > 0) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Os e-mails informados não são iguais!')))]) : _vm._e(), _vm._v(" "), (_vm.entidade.ds_email === _vm.usuario.ds_email && _vm.entidade.ds_email && _vm.usuario.ds_email) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('Os e-mails da entidade e do usuário não podem ser iguais!')))]) : _vm._e()])])])])])]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), (_vm.mostrarForm === true && !_vm.telaTodosEditais) ? _c('div', {
    staticClass: "box-footer"
  }, [((_vm.mostrarForm && !_vm.mostrarArquivo && !_vm.mostrarCriarProposta && _vm.entidadesVoluntariadoDump.length <= 0) && !_vm.gravando) ? _c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.grava()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), ((_vm.mostrarForm && _vm.mostrarArquivo && _vm.validacaoArquivo)) ? _c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.gravaViaArquivo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo yellow-bg logo-container-edital",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo-login.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "edital-subtitulo"
  }, [_c('b', [_vm._v("Clique no link abaixo")]), _vm._v(" para acessar e atualizar as informações .")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b', [_vm._v("ATENÇÃO")]), _vm._v(": os documentos apresentados serão utilizados "), _c('b', [_vm._v("apenas para fins de atualização do cadastro")]), _vm._v(" e "), _c('b', [_vm._v("NÃO")]), _vm._v(" serão utilizados para análise da proposta.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "edital-subtitulo"
  }, [_vm._v("Após atualizar o seu cadastro, clique no botão "), _c('b', [_vm._v("Criar Proposta")]), _vm._v(" abaixo.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "edital-subtitulo"
  }, [_vm._v("Nesse caso "), _c('b', [_vm._v("não é necessário")]), _vm._v(" preencher os dados da Entidade e nem do representante legal.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-logo yellow-bg",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo-login.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border",
    attrs: {
      "align": "center"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', {
    staticStyle: {
      "color": "dimgrey"
    }
  }, [_vm._v("SGP - Autocredenciamento")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a94b76d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AutoCredenciamento.vue
// module id = 1980
// module chunks = 2